<template>
  <div>
    <el-row :gutter="20">
      <el-col :span="24">
        <el-form inline ref="form" label-width="120px" :model="autoForm">
          <el-form-item>
            <el-tag type="danger" style="font-size:14px;font-weight:bold;height:40px;line-height:40px;margin-right:10px">手动上传软件包: </el-tag>
          </el-form-item>

          <el-form-item>
            <el-button size="medium" type="primary" style="height:40px;margin-right:10px" @click="showUploadDialog">上传软件包并生成下载链接</el-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-row>

    <List
      url="device-rom/download/"
      :title="title"
      :data="searchData"
      :tanle="tanle"
      :afterList="dealList"
      :operat="operation"
      :update="updateList"
      :MultipleSel="true"
      @edit="edit"
      @deletedata="deletedata"
    >
      <div slot="Fresh" style="float:right;">
        <el-select multiple v-model="selectClouds" placeholder="选择存储区域(多选)"
          style="width:200px;margin-right:10px;"
          size="small">
          <el-option
            v-for="item in deviceRomStorageList"
            :label="item.name"
            :key="item.id"
            :value="item.name"
            @click.native="handleCloudSelectClick(item.name)"
            ></el-option>
        </el-select>
        <el-input
          v-model="searchData.rom_name"
          size="small"
          style="width:150px;margin-right:10px;"
          placeholder="请输入软件包名称"
          @change="search"
        ></el-input>
        <el-input
          v-model="searchData.dclient_ver"
          size="small"
          style="width:150px;margin-right:10px;"
          placeholder="请输入Dclient版本"
          @change="search"
        ></el-input>

        <label>任务状态：</label>
        <el-select v-model="selectStatus" placeholder="选择任务状态" @change="search" style="width:150px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="status in deviceRomTaskStatus"
            :label="status"
            :key="status"
            :value="status"></el-option>
        </el-select>

        <label>固件版本类型：</label>
        <el-select v-model="selectReleaseType" placeholder="选择固件版本类型" @change="search" style="width:150px;margin-right:10px;" size="small">
          <el-option value="全部" label="全部"></el-option>
          <el-option
            v-for="release_type in deviceRomReleaseTypes"
            :label="release_type"
            :key="release_type"
            :value="release_type"></el-option>
        </el-select>

        <el-tooltip placement="top" :hide-after="3000">
          <div slot="content">如果 升级包名称、dclient版本、存储位置 这3个选项与已存在的一致，则修改已有的下载链接，否则添加新下载链接</div>
          <el-button
            @click="add"
            type="primary"
            size="small"
            icon="el-icon-edit"
            >手动添加</el-button>
        </el-tooltip>
        <el-button @click="updateList++" type="primary" size="small">刷新列表</el-button>
      </div>
    </List>
    <DeviceRomDownloadUpdateBox
      :initForm="updateForm"
      :updateType="updateType"
      v-if="updateBlock"
      @close="close"
      @update="updateList++"
      :clouds="deviceRomStorageList"
    ></DeviceRomDownloadUpdateBox>

    <el-dialog title="手动上传软件包" :visible.sync="uploadDialogVisible" :close-on-click-modal="false" width="70%">
      <el-form :model="currentTask" :rules="rules" ref="taskForm" label-width="120px">
        <el-row :gutter="10" class="el-row">
          <el-col :span="8">
            <el-form-item label="选择文件" prop="file">
              <el-upload
                ref="upload"
                :action="uploadUrl()"
                :auto-upload="false"
                :on-change="handleFileChange"
                :file-list="fileList"
                :limit="1"
                :headers="config">
                <el-button slot="trigger" size="medium" type="primary">选择软件包文件</el-button>
              </el-upload>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="软件包版本" prop="version">
              <el-input v-model="currentTask.version" placeholder="请输入软件包版本"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="Dclient版本" prop="dclientVer">
              <el-input v-model="currentTask.dclientVer" placeholder="请输入Dclient版本"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="版本类型" prop="release_type">
              <el-select v-model="currentTask.release_type" placeholder="选择版本类型">
                <el-option
                  v-for="release_type in deviceRomReleaseTypes"
                  :label="release_type"
                  :key="release_type"
                  :value="release_type">
                </el-option>
              </el-select>
              <el-checkbox v-model="currentTask.setAsLatest" style="margin-left: 10px">设为最新版本（非版本发布管理人员，请不要勾选）</el-checkbox>
            </el-form-item>
            </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="存储区域" prop="clouds">
              <el-select multiple v-model="currentTask.clouds" placeholder="选择存储区域(多选)">
                <el-option
                  v-for="item in deviceRomStorageList.filter(item => item.name !== '全部')"
                  :label="item.name"
                  :key="item.id"
                  :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="变更记录_英文" prop="changeLogEn">
              <el-input type="textarea" :rows="5" v-model="currentTask.changeLogEn" placeholder="请填写变更记录"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="变更记录_中文" prop="changeLogCn">
              <el-input type="textarea" :rows="5" v-model="currentTask.changeLogCn" placeholder="请填写变更记录"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24">
            <el-form-item label="变更记录_日文" prop="changeLogJp">
              <el-input type="textarea" :rows="5" v-model="currentTask.changeLogJp" placeholder="请填写变更记录"></el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10" class="el-row">
          <el-col :span="24" class="button-container">
            <el-form-item>
              <el-button type="primary" @click="addTask">添加到任务列表</el-button>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>

      <el-card>
        <h4>任务列表</h4>
        <el-table :data="tasks" style="width: 100%; margin-top: 20px;">
          <el-table-column prop="file.name" label="文件名" width="180"></el-table-column>
          <el-table-column prop="version" label="软件包版本" width="180"></el-table-column>
          <el-table-column prop="dclientVer" label="Dclient版本" width="180"></el-table-column>
          <el-table-column prop="clouds" label="存储区域" width="180" :formatter="formatClouds"></el-table-column>
          <el-table-column label="进度" width="120">
            <template slot-scope="scope">
              <el-progress :percentage="scope.row.progress"></el-progress>
            </template>
          </el-table-column>
          <el-table-column prop="status" label="状态" width="120"></el-table-column>
          <el-table-column label="操作" width="100">
            <template slot-scope="scope">
              <el-button @click="removeTask(scope.$index)" type="link" size="small">移除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-card>

      <span slot="footer" class="dialog-footer">
        <el-button @click="uploadDialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitAllTasks">提交</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { DeviceRomTaskStatus, DeviceRomReleaseTypes } from "../components/Index/data.js";
import List from "../components/common/List.vue";
import DeviceRomDownloadUpdateBox from "../components/DeviceRom/DeviceRomDownloadUpdateBox.vue";

export default {
  components: {
    List,
    DeviceRomDownloadUpdateBox
  },
  data() {
    return {
      autoForm: {
        romName: "",
        version: "",
        dclientVer: "",
        changeLogEn: "",
        changeLogCn: "",
        changeLogJp: "",
        clouds: []  // 表单中选中的 cloud 列表
      },
      rules: {
        file: [{ required: true, message: "请选择文件", trigger: "change" }],
        version: [{required: true, message: "请输入软件包版本", trigger: "blur"}],
        dclientVer: [{required: true, message: "请输入Dclient版本", trigger: "blur"}],
        release_type: [{required: true, message: "请选择版本类型", trigger: "blur"}],
        clouds: [{required: true, message: "请选择云平台", trigger: "blur"}]
      },
      deviceRomStorageList: [],  // 从后端获取的 cloud 列表
      selectClouds: [],
      selectStatus: "全部",
      selectReleaseType: "全部",
      deviceRomTaskStatus: DeviceRomTaskStatus,
      deviceRomReleaseTypes: DeviceRomReleaseTypes,
      fileList: [],
      title: "软件包下载链接",
      tanle: [
        { name: "rom_name", label: "软件包名称" },
        { name: "dclient_ver", label: "Dclient版本" },
        { name: "cloud", label: "存储区域" },
        { name: "url", label: "下载链接", status: "copyStatus" },
        { name: "human_readable_size", label: "文件大小" },
        { name: "cloud_api_uuid_list", label: "发布到对讲云", status: "tagStatus" },
        { name: "statusName", label: "任务状态", status: "taskStatus" },
        { name: "releaseTypeName", label: "固件版本类型" },
        { name: "rom_tag", label: "标签信息", status: "romTag" },
        { name: "update_time", label: "修改时间" },
        { name: "operator", label: "操作人" }
      ],
      searchData: {
        rom_name: "",
        dclient_ver: "",
        cloud: "",
        status: "",
        release_type: "",
      },
      operation: [
        {
          text: "Edit",
          eventName: "edit"
        },
        {
          text: "Deletedata",
          eventName: "deletedata"
        }
      ],

      updateList: 0,
      updateForm: {},
      updateType: "edit",
      updateBlock: false,
      token: "",
      uploadDialogVisible: false,
      currentTask: {
        file: null,
        version: "",
        dclientVer: "",
        changeLogEn: "",
        changeLogCn: "",
        changeLogJp: "",
        clouds: [],
        status: "待上传",
        release_type: "",
        setAsLatest: false,
        progress: 0
      },
      tasks: []
    };
  },
  mounted() {
    this.token = localStorage.getItem("token");
    this.fetchStorageNames();
  },
  methods: {
    showUploadDialog() {
      this.uploadDialogVisible = true;
    },
    handleFileChange(file, fileList) {
      this.currentTask.file = file;
      const fileName = file.name;
      const version = fileName.substring(0, fileName.lastIndexOf('.'));
      this.currentTask.version = version;
      this.currentTask.dclientVer = "6500";
      console.log('FileList: ', fileList);
    },
    addTask() {
      this.$refs.taskForm.validate((valid) => {
        if (valid) {
          this.tasks.push({ ...this.currentTask });
          this.currentTask = {
            file: null,
            version: "",
            dclientVer: "",
            release_type: "",
            setAsLatest: false,
            changeLogEn: "",
            changeLogCn: "",
            changeLogJp: "",
            clouds: [],
            status: "待上传",
            progress: 0
          };
          this.fileList = [];
        }
      });
    },
    removeTask(index) {
      this.tasks.splice(index, 1);
    },
    fetchStorageNames() {
      this.$http["get"](
        "device-rom/storage/", {}, (data) => {
          this.deviceRomStorageList = data.data.results.map(item => {
            return {id: item.id, name: item.cloud};
          });
          if (this.deviceRomStorageList.length > 0) {
            this.deviceRomStorageList.unshift({id: 'all', name: '全部'});
          }
        });
    },
    withTimeout(promise, timeout) {
      return Promise.race([
        promise,
        new Promise((_, reject) => setTimeout(() => reject(new Error('请求超时')), timeout))
      ]);
    },
    async submitAllTasks() {
      if (this.tasks.length === 0) {
        this.$message.warning("没有任务可提交");
        return;
      }

      // 过滤掉已经上传成功的任务
      const tasksToUpload = this.tasks.filter(task => task.status !== "上传成功");
      if (tasksToUpload.length === 0) {
        this.$message.warning("所有任务已经上传成功，无需重复上传");
        return;
      }

      const TIMEOUT = 900000;  // 900秒
      for (const task of tasksToUpload) {
        const loading = this.$loading({
          lock: true,
          text: "正在处理，请不要关闭网页",
          background: "rgba(255, 255, 255, 0.1)"
        });
        task.status = "上传中";
        const formData = new FormData();
        formData.append('file', task.file.raw);
        try {
          await this.withTimeout(this.uploadFile(task, formData), TIMEOUT);
          await this.withTimeout(this.createDeviceRomTask(task), TIMEOUT);
          task.status = "上传成功";
        } catch (error) {
          task.status = "上传失败";
          this.$message.error(task.file.name + ": 任务处理失败：" + error.message);
        } finally {
          loading.close();
        }
      }

      if (this.tasks.every(task => task.status === "上传成功")) {
        this.$message.success("任务全部上传成功");
        this.uploadDialogVisible = false;
      } else {
        this.$message.warning("部分任务上传失败，请重新提交失败的任务");
      }
      this.updateList++;
    },
    uploadUrl() {
      return this.$http.host + "device-rom/upload/";
    },
    async uploadFile(task, formData) {
      return new Promise((resolve) => {
        this.$http.postOptions(
          "device-rom/upload/",
          formData,
          {
            onUploadProgress: (progressEvent) => {
              // 计算上传进度
              const progress = Math.round((progressEvent.loaded * 100) / progressEvent.total);
              task.progress = progress;
            }
          },
          (res) => {
            resolve(res.data);
          }
        );
      });
    },
    async createDeviceRomTask(task) {
      return new Promise((resolve) => {
        this.$http.post("device-rom/creater/",
          {
            rom_name: task.file.name,
            cloud: task.clouds.join(','),
            version: task.version,
            dclient_ver: task.dclientVer,
            release_type: DeviceRomReleaseTypes.indexOf(task.release_type),
            set_latest: task.setAsLatest,
            change_log_en: task.changeLogEn,
            change_log_cn: task.changeLogCn,
            change_log_jp: task.changeLogJp
          },
          (res) => {
            resolve(res.data);
          }
        );
      });
    },
    formatClouds(row, column, cellValue) {
      console.log('row: ', row, 'column: ', column);
      return cellValue.join(', ');
    },
    dealList(data) {
      for (let i in data) {
        data[i].statusName = DeviceRomTaskStatus[data[i].status];
        data[i].releaseTypeName = DeviceRomReleaseTypes[data[i].release_type];
        data[i].update_time = this.changeDate(data[i].update_time);
      }
      return data;
    },
    close() {
      this.updateBlock = false;
    },
    add() {
      this.updateType = "add";
      this.updateForm = {};
      this.updateBlock = true;
    },
    edit(val) {
      this.updateType = "edit";
      this.updateForm = Object.assign({}, val);
      this.updateForm.release_type = DeviceRomReleaseTypes[val.release_type];
      this.updateBlock = true;
    },
    search() {
      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = DeviceRomTaskStatus.indexOf(this.selectStatus);
      };

      if (this.selectReleaseType === '全部') {
        this.searchData.release_type = "";
      } else {
        this.searchData.release_type = DeviceRomReleaseTypes.indexOf(this.selectReleaseType);
      };
      this.updateList++;
    },
    handleCloudSelectClick(cloud){
      const isHasAllOption= this.selectClouds.some(item => item === '全部');
      const curSelectIsAllOption = cloud === '全部';
      if(isHasAllOption && curSelectIsAllOption){
        this.selectClouds = ['全部'];
      }else if(isHasAllOption && !curSelectIsAllOption){
        this.selectClouds = [cloud];
      }
      this.searchData.cloud = isHasAllOption && curSelectIsAllOption?'':this.selectClouds.join(",");
      this.search();
    },
    handleStatusSelectChange() {
      if (this.selectStatus === '全部') {
        this.searchData.status = "";
      } else {
        this.searchData.status = DeviceRomTaskStatus.indexOf(this.selectStatus);
      };
      this.search();
    },
    deletedata(val) {
      let url = "device-rom/download/" + val.id + "/";
      this.$http["delete"](url, () => {
        this.$baseNotice.message("删除成功");
        this.updateList++;
      });
    },
    changeDate(date) {
      var time = new Date(date);
      var nowYear = time.getFullYear().toString();
      var nowMonth = (time.getMonth() + 1).toString();
      var nowDay = time.getDate().toString();
      var nowHours = time.getHours().toString(); //获取当前小时数(0-23)
      var nowMin = time.getMinutes().toString(); //获取当前分钟数(0-59)
      var nowSeconds = time.getSeconds().toString(); //获取当前秒数(0-59)

      nowYear = this.timeAdd0(nowYear);
      nowMonth = this.timeAdd0(nowMonth);
      nowDay = this.timeAdd0(nowDay);
      nowHours = this.timeAdd0(nowHours);
      nowMin = this.timeAdd0(nowMin);
      nowSeconds = this.timeAdd0(nowSeconds);
      return (
        nowYear +
        "-" +
        nowMonth +
        "-" +
        nowDay +
        " " +
        nowHours +
        ":" +
        nowMin +
        ":" +
        nowSeconds
      );
    },
    timeAdd0(str) {
      if (str.length <= 1) {
        str = "0" + str;
      }
      return str;
    }
  },
  computed: {
    config() {
      return { Authorization: "JWT " + this.token };
    }
  }
};
</script>

<style lang="less" scoped>
.tag {
  height: 36px;
  width: 120px;
  line-height: 36px;
  font-size: 14px;
  background-color: #d7dbe0;
  color: #303133;
  margin-right: 20px;
  padding: 0px 16px;
  text-align: center;
}

.el-row {
  margin-bottom: 0px;
  &:last-child {
    margin-bottom: 0;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
.row-bg {
  padding: 10px 0;
  background-color: #f9fafc;
}
.button-container {
  display: flex;
  justify-content: flex-end; /* 将内容右对齐 */
}

.el-loading-spinner .path {
  stroke: rgb(218, 41, 10);
}
</style>
